import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { CheckIcon } from 'lucide-react';
import { cn } from '@/utils';

function FilterCheckbox({ className, ...props }: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        `aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs peer size-6 shrink-0 rounded-[4px] border
        border-secondary-grey-03 bg-primary-website-background-colour outline-none transition-all focus-visible:border-ring
        focus-visible:ring-[3px] focus-visible:ring-focus-ring disabled:cursor-not-allowed disabled:opacity-50
        data-[state=checked]:border-ring data-[state=checked]:bg-ring data-[state=checked]:text-primary-foreground
        data-[state=unchecked]:hover:border-ring`,
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { FilterCheckbox };
